import { IUserInfo } from './type';

export const userInfoKey = 'carbon-Ai-user-info';
export const tokenKey = 'token';

export const getUserInfo = () => {
  const stringInfo = localStorage.getItem(userInfoKey) || '{}';
  try {
    return JSON.parse(stringInfo) as IUserInfo;
  } catch (error) {
    return null;
  }
};
export const setUserInfo = (info: IUserInfo) => {
  localStorage.setItem(tokenKey, info.accessToken);
  localStorage.setItem(userInfoKey, JSON.stringify(info));
};

export const Token = (() => localStorage.getItem(tokenKey))();
